import * as React from "react";
import { useFormContext } from "react-hook-form";
import Select, { createFilter, ValueType } from 'react-select';
import { MenuList, SelectStyles } from "soprasteria-ui-library";
import { IOrthodonticReferralToothDeviation } from "../../models/IOrthodonticReferral";

interface IOption {
    value: string;
    label: string;
    selected?: boolean;
}

interface IToothDeviationDropdown {
    toothDeviations: IOrthodonticReferralToothDeviation[];
    defaultValues?: string[];
    name: string;
    required?: boolean;
    labelCol?: number;
    inputCol?: number;
    placeholder?: string;
    disabled?: boolean;
    useFixedListItemHeight?: boolean;
    isClearable?: boolean;
}

export const ToothDeviationDropdown: React.FunctionComponent<IToothDeviationDropdown> = ({ toothDeviations, defaultValues, name, required, inputCol, labelCol, placeholder, disabled, useFixedListItemHeight, isClearable }) => {

    const { register, setValue, errors, unregister } = useFormContext();
    const [selectedValues, setSelectedValues] = React.useState<IOption[]>();
    const [toothDeviationsOptions, setToothDeviationOptions] = React.useState<IOption[]>([]);
    const abortController = new AbortController();
    var selectRef = React.useRef<any>();

    React.useEffect(() => {
        if (!disabled && defaultValues === undefined && toothDeviations && toothDeviations.length > 1) {
            document.getElementById("clear-form")?.addEventListener("click", resetValue);
        }

        return () => {
            document.getElementById("clear-form")?.removeEventListener("click", resetValue)
        }
    }, [toothDeviations])

    const resetValue = () => {
        if (selectRef?.current) {
            selectRef.current.select.clearValue();
            setValue(name, undefined);
            setSelectedValues(undefined);
        }
    }

    React.useEffect(() => {
        register({ name: name }, { required: required });

        const options = toothDeviations.map<IOption>((toothDeviation) => {
            return {
                value: toothDeviation.orthodonticReferralToothDeviationTypeId.toString(),
                label: `${toothDeviation.description}`
            }
        })
        setToothDeviationOptions(options);


        const initialValues = options.filter((option) => { return defaultValues?.includes(option.value) })
        if (initialValues && initialValues.length > 0) {
            setValue(name, initialValues.map(option => { return option.value }));
            setSelectedValues(initialValues);

        } else {
            setValue(name, undefined);
            setSelectedValues(undefined);
        }

        return () => {
            abortController.abort();
            unregister(name);
        }
    }, [toothDeviations, defaultValues, required])

    const valueChange = (selectedOption: any | null) => {
        if (selectedOption && selectedOption.length > 0) {
            setValue(name, selectedOption.map((option: IOption) => { return option.value }));
            setSelectedValues(selectedOption);
        }
        else {
            setValue(name, undefined);
            setSelectedValues(undefined)
        }
    }

    return (
        <div className="form-group row">
            <label className={`col-${labelCol ?? 4} col-form-label`}>Tandavvikelse finns angående:{required ? "*" : ""}</label>
            <div className={`col-${inputCol ?? 8}`}>
                {
                    React.cloneElement(
                        <Select
                            ref={selectRef}
                            loadingMessage={() => { return "Laddar..." }}
                            noOptionsMessage={() => { return "Det finns inga valbara tandavvikelser" }}
                            placeholder={placeholder ? placeholder : "Välj"}
                            filterOption={createFilter({ ignoreAccents: false })}
                            options={toothDeviationsOptions}
                            isOptionSelected={(option: IOption) => option.selected === true}
                            value={selectedValues}
                            onChange={(selectedOption: any) => valueChange(selectedOption)}
                            components={useFixedListItemHeight ? { MenuList } : undefined}
                            styles={useFixedListItemHeight ? SelectStyles : undefined}
                            isDisabled={(defaultValues !== undefined && toothDeviationsOptions?.length === 1) || disabled}
                            isClearable={isClearable !== undefined ? isClearable : true}
                            isMulti={true}
                        />
                    )
                }
                <span className="text-danger">{errors ? [name] && (errors[name] as any)?.type === "required" && "Välj en tandavvikelse" : ""}</span>
            </div>
        </div >
    )
}